import Vue from 'vue'
import store from './store'
import router from './router'
import Mint from 'mint-ui'
import App from './App.vue'
import components from '@/components'
import 'mint-ui/lib/style.css'
import '@/assets/css/index.scss' // global css
import '@/assets/iconfont/iconfont.css' // 引用图标
import 'animate.css' // 引入动画
import { List, Empty, Popup, PullRefresh, Image as VanImage, Lazyload, ActionSheet } from 'vant'

// // 将px转换为rem
// import 'amfe-flexible/index.js';
// 环境初始化
import '@/utils/init/env-init'
import '@/utils/common/date.js'
// 全局的wx方法
import $wx from '@/utils/init/wx.js'
window.$wx = $wx
import './permission'

import VueAppend from 'vue-append'

// 初始化页面配置
import { useConfig } from '@/pages/config'
useConfig()

Vue.use(Mint)
Vue.use(PullRefresh)
Vue.use(List)
  .use(VanImage)
  .use(Empty)
  .use(Lazyload)
  .use(Popup)
  .use(ActionSheet)
Vue.use(VueAppend)
Vue.use(components)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
